import { Outlet, useRouterState } from '@tanstack/react-router';
import { useStravaStatus } from '../api/queries';
import type { SessionUser } from '../auth/session';
import { PoweredByStrava } from '../components/PoweredByStrava';
import { UploadQueueProvider } from '../features/upload/UploadQueueProvider';
import { PhoneTabBar } from '../ui/PhoneTabBar';
import { AppBar } from './AppBar';
import { showsStravaAttribution } from './appBarModel';
import styles from './app.module.css';

export function AppLayout({ user }: { user: SessionUser }) {
  const strava = useStravaStatus();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <UploadQueueProvider>
      <div className={styles.shell}>
        <AppBar user={user} strava={strava.data} />
        <main className={styles.main}>
          <Outlet />
          {showsStravaAttribution(pathname, strava.data) && <footer className={styles.attribution}><PoweredByStrava /></footer>}
        </main>
        <PhoneTabBar />
      </div>
    </UploadQueueProvider>
  );
}
